'use client'

import clsx from 'clsx'
import { ButtonHTMLAttributes, useCallback, useEffect } from 'react'
import { useSwiper } from 'swiper/react'

import cl from './SlideButtons.module.scss'

type SlideNextButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
	className?: string
}

export const SliderNextButton = (props: SlideNextButtonProps) => {
	const { className, disabled, type = 'button', onClick, ...restProps } = props

	const swiper = useSwiper()

	const handleSwipeOnKeyDown = useCallback(
		(e: KeyboardEvent) => {
			if (!disabled && e.key === 'ArrowRight') swiper?.slideNext()
		},
		[disabled, swiper]
	)

	useEffect(() => {
		document.body.addEventListener('keydown', handleSwipeOnKeyDown)

		return () => {
			document.body.removeEventListener('keydown', handleSwipeOnKeyDown)
		}
	}, [handleSwipeOnKeyDown, swiper])

	return (
		<button
			type={type}
			disabled={disabled}
			onClick={onClick ?? (() => swiper.slideNext())}
			className={clsx(cl.root, className)}
			aria-label="Перейти к следующему слайду"
			title="Следующий слайд"
			{...restProps}>
			<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
				<path
					d="M3.29289 13.7071C2.90237 13.3166 2.90237 12.6834 3.29289 12.2929L8.58579 7L3.29289 1.70711C2.90237 1.31658 2.90237 0.683417 3.29289 0.292893C3.68342 -0.0976315 4.31658 -0.0976315 4.70711 0.292893L10.7071 6.29289C11.0976 6.68342 11.0976 7.31658 10.7071 7.70711L4.70711 13.7071C4.31658 14.0976 3.68342 14.0976 3.29289 13.7071Z"
					fill="#545563"
				/>
			</svg>
		</button>
	)
}
